export const Mobile = /^1[3-9]\d{9}$/;

export const BsName = /^[0-9a-zA-Z\s?]+$/;

export const UsaName = /^[0-9a-zA-Z\s?]+$/;

export const IDNumber = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;

export const Email = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;

export const Company_EN = /^[\w\s\.]+$/g;

export const Company_CN = /^[\u4e00-\u9fa5\s\.]+$/;
export const User_CN = /^[\u4e00-\u9fa5\s]+$/;

export const Password = /^[\u0020-\u007E]{6,16}$/;

export const ChineseName = /^[\u4E00-\u9FA5]{2,15}$/;

export const NumberCode = /^\d{6}$/;

